import { CustomEvents } from '../../../../../services/custom-events';
import InputField from '../../../services/input-fields/input-field';
import DateTimeField from '../input-fields/datetime-field';
import Unibar from '../input-fields/unibar';
import { getWidgetForm } from '../models/form';
import { validateFlight } from './flight-validator';
import { validateField, validateNoFlight } from './validator';

export default function loadValidations(): void {
    const form = getWidgetForm();

    CustomEvents.subscribe('ValidateField', (args: { field: InputField }) => validateField(args.field));

    CustomEvents.subscribe('ValidateFlightNoUpdateNoReturn', () => {
        validateFlight(form.row1.flight.flightNumber, form.row1.flight.flightDate, false);
    });

    CustomEvents.subscribe('TransferPointChanged', (args: { isReturn: boolean }) => {
        const point = args.isReturn
            ? form.row2.noflight
            : form.row1.noflight;

        validateNoFlight(point.from, point.to, point.datetime);
    });

    // Validate each field when the value changes
    [form.row1, form.row2]
        .reduce((arr, b) => arr.concat([
            // Fields to be validated:
            b.noflight.from,
            b.noflight.to
        ]), [] as Array<InputField | null>)
        .forEach(field => {
            if (!field) return;

            if (field.$JQuery.hasClass('datepicker')
                || field.$JQuery.hasClass('datetimepicker')
                || field.$JQuery.hasClass('airport-search')) {
                if (field instanceof DateTimeField) {
                    field.$JQuery.blur(() => validateField(field, true));
                    field.hours.$JQuery.change(() => validateField(field, true));
                    field.minutes.$JQuery.change(() => validateField(field, true));
                } else {
                    field.$JQuery.blur(() => validateField(field));
                }
            } else if (field instanceof Unibar) {
                const bar = field as Unibar;
                bar.$JQuery.change(() => setTimeout(() => {
                    bar.done.then<any>(() => validateField(field));
                }, bar.inputTimeout + 20));
            } else {
                field.$JQuery.change(() => validateField(field));
            }
        });
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/scripts/modules/widget-core/validation/validation-loader.ts